import { render, staticRenderFns } from "./DatosLegales.vue?vue&type=template&id=bc22a380&scoped=true"
import script from "./DatosLegales.vue?vue&type=script&lang=js"
export * from "./DatosLegales.vue?vue&type=script&lang=js"
import style0 from "./DatosLegales.vue?vue&type=style&index=0&id=bc22a380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc22a380",
  null
  
)

export default component.exports